<template>
  <div class="continer">
    <HeaderTop></HeaderTop>
    <CompanyTitle></CompanyTitle>
    <RouterList></RouterList>
    <Banner></Banner>
    <!-- 面包屑 -->
    <div class="navigation">
      <span>当前位置&nbsp;:&nbsp;</span>
      <router-link to="/">&nbsp;首页&nbsp;>&nbsp;</router-link>
      <router-link to="/reply">回复指南&nbsp;>&nbsp;</router-link>
      <span style="color:#016bff">{{this.detailsList.lable}}</span>
    </div>
    <!-- 版心 -->
    <div class="details">
      <h5>{{this.detailsList.lable}}</h5>
      <h6>发布时间:&nbsp;{{this.detailsList.updataTime}}</h6>
      <p v-html="this.detailsList.content"></p>
      <div class="imgList">
        <img v-if="showImg" :src="this.detailsList.picture" alt="">
        <!-- <img src="../assets/img/result.png" alt=""> -->
      </div>
      <h3>本文档仅供设计者学习、参考,正式使用请购买正版!</h3>
      <h2>附件下载</h2>
      <div class="pdfList">
        <ul>
          <li @click="changePdf(item)" v-for="(item,index) in pdfList" :key="index">
            <img src="../../assets/img/Pdf.png" alt="">
            <p>{{item.name}}</p>
          </li>
        </ul>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import { guide_queryId } from '../../api/user/index'
import {  ERR_OK } from '../../api/common/config'
import HeaderTop from '@/components/header-top/header-top.vue'
import CompanyTitle from '@/components/company-title/company-title.vue'
import RouterList from '@/components/router-list/router-list.vue'
import Banner from '@/components/banner/banner.vue'
import Footer from '@/components/footer/footer.vue'
export default {
  components: {
    HeaderTop,
    CompanyTitle,
    RouterList,
    Banner,
    Footer
  },
  data() {
    return {
      detailsList:{},
      showImg:true,
      pdfList:[]
    }
  },
  mounted(){
    this.id = this.$route.query.id
    // console.log(this.id)
    this._guide_queryId()
  },
  methods: {
    changePdf (item) {
      window.open(item.url)
    },
    _guide_queryId () {
      guide_queryId({id:this.id}).then((res)=>{
        console.log(res)
        if(res.data.isok === ERR_OK){
          this.detailsList = res.data.data
          // console.log(this.detailsList)
          this.pdfList = JSON.parse(res.data.data.pdf)
          if(this.detailsList.picture == ''){
            this.showImg = false
          }
        }
      })
    }
  },
}
</script>
<style lang="stylus" scoped>
.continer
  .navigation
    width 1200px
    height 52px
    background rgba(255,255,255,1)
    margin 30px auto 10px
    box-shadow 0px 0px 10px 0px rgba(0, 0, 0, 0.05)
    font-size 12px
    padding 18px 20px
    box-sizing border-box
    span,a 
      color #666666
    a:nth-child(4)
      color #3377FF
  .details
    width 1200px
    margin 0 auto
    // height 486px
    background rgba(255,255,255,1)
    box-shadow 0px 0px 8px 0px rgba(0, 0, 0, 0.06)
    margin-bottom 110px
    padding 30px 40px
    box-sizing border-box
    h5 
      text-align center
      font-size 24px
      margin-bottom 26px
    h6 
      text-align center
      font-size 12px
      color #999
      margin-bottom 42px
    h3 
      font-size 12px
      color #333
      margin-bottom 44px
    h2 
      font-size 16px
      color #333
      font-weight bold
      margin-bottom 30px
    p 
      text-indent 2em
      font-size 12px
      color #333
      margin-bottom 45px
    .imgList
      display flex
      flex-wrap wrap 
      padding 0 30px
      box-sizing border-box
      justify-content space-between
      min-height 400px
      img 
        width 492px
        height 336px
        display block
        margin-bottom 20px
    .pdfList
      padding 0 30px
      box-sizing border-box
      ul 
        display flex
        flex-wrap wrap 
        justify-content space-between
        li 
          width 330px
          height 120px
          text-align center
          img 
            width 68px
            height 70px
            margin-bottom 20px
            // display block
          p 
            font-size 12px
            color #FF0202
</style>
